import { render } from "./TranslateIcon.vue?vue&type=template&id=81251c34"
import script from "./TranslateIcon.vue?vue&type=script&lang=js"
export * from "./TranslateIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__